import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  tagTypes: ['User'],
  endpoints: (builder) => ({
    // Login endpoint
    login: builder.mutation({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: {
          email: credentials.email,
          password: credentials.password,
        },
      }),
      invalidatesTags: ['User'],
    }),

    // Validate an invite code from the invite landing page (no auth required)
    validateInvite: builder.mutation({
      query: (inviteCode) => ({
        url: `/invite/validateInvite/${inviteCode}`,
        method: 'POST',
      }),
    }),

    // Logout endpoint
    logout: builder.mutation({
      query: () => ({
        url: '/logout',
        method: 'GET',
      }),
      invalidatesTags: ['User'],
    }),

    // Get current user - called after SSO login to validate user in backend
    getCurrentUser: builder.query({
      query: () => '/users/me',
      providesTags: ['User'],
      transformResponse: (response) => ({
        id: response.id,
        email: response.email,
        firstName: response.firstName,
        lastName: response.lastName,
        name: `${response.firstName || ''} ${response.lastName || ''}`.trim(),
        portfolioId: response.portfolioId,
        portfolioName: response.portfolioName,
        roles: response.roles || [],
        useBrowserTimeZone: response.useBrowserTimeZone ?? true,
        timeZone: response.timeZone || null,
        picture: response.picture || null,
      }),
    }),

    // Switch portfolio for current user
    switchPortfolio: builder.mutation({
      query: (portfolioId) => ({
        url: '/users/changePortfolio',
        method: 'PUT',
        body: { portfolioId },
      }),
      invalidatesTags: ['User'],
    }),

    // Update user (timezone, etc.)
    updateUser: builder.mutation({
      query: (data) => ({
        url: '/users/updateMe',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useValidateInviteMutation,
  useGetCurrentUserQuery,
  useSwitchPortfolioMutation,
  useUpdateUserMutation,
} = authApi;
